<template>
  <div ref="widget" :class="['swap-widget', isSwapOpen ? 'is-open' : 'closed']">
    <div class="swap-wrapper" ref="wrapper">
      <div class="swap-items">
        <p>Select a value to substitute</p>
        <p class="swap-link"
           @click="$emit('insertInTextArea', values.name)">customer first name</p>
        <p class="swap-link"
            v-if="showMemberBalance"
           @click="$emit('insertInTextArea', values.points_balance)">customer points balance</p>
        <p class="swap-link"
           v-if="showExpiration"
           @click="$emit('insertInTextArea', values.expiration_date)">date of point expiration</p>
        <p class="swap-link"
           v-if="showExpiration"
           @click="$emit('insertInTextArea', values.expiration_points)">expiring points</p>
        <!--<p class="swap-link"
           @click="$emit('insertInTextArea', values.last_transaction)">customer last transaction points earned</p>-->
        <!--<p class="swap-link"
           @click="$emit('insertInTextArea', values.link)">customer wallet link</p>-->
      </div>
      <sms-action-footer @closeAction="$emit('closeSwap', 'swap', true)"></sms-action-footer>
    </div>
  </div>
</template>

<script>
  import SmsActionFooter from '../Sms/SmsActionFooter'

  export default {
    props: {
      isSwapOpen: Boolean,
      showMemberBalance: {type: Boolean, default: true},
      showExpiration: {type: Boolean, default: true}
    },

    name: 'MemberValue',

    components: {
      SmsActionFooter,
    },

    data() {
      return {
        values: {
          points_balance: '%{MEMBER_BALANCE}',
          last_transaction: '%{MEMBER_LAST_TRANSACTION_POINTS}',
          name: '%{MEMBER_FIRST_NAME}',
          link: '%{MEMBER_LINK}',
          expiration_points: '%{EXPIRATION_POINTS}',
          expiration_date: '%{EXPIRATION_DATE}'
        }
      };
    }
  }
</script>
